import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getBetsByPattern=(pattern,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_BETS_BY_PATTERN_START,
    })
    const options={
        url:`${api}/bets/pattern?pattern=${pattern}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_BETS_BY_PATTERN_SUCCESS,
                payload:{
                    data:response.data?.sort((a,b)=>b.smasterBetAmount - a.smasterBetAmount),
                    pattern
                }
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_BETS_BY_PATTERN_FAIL,
                payload:getMessage(error)
            }))
}